import {de as tooltips} from "../tooltips";

export const casmon_deutsch = {

    routes: {
        overview: 'Übersicht', // TODO - Übersetzung ergänzen
        reporting_root_page: "Reports",
        reporting_overview: "Report Übersicht",
        custom_reporting: "Benutzerdefinierte Reports",
        events: "Events",
        reprocessing: "Wieder-verarbeitung",
        files: "Dateien",
        integration: "Integrationen",
        systems: 'Systeme',
        alerting_mail: 'Alerting-Mail',
        mail_template: 'Mail-Template',
        data: 'Daten',
        user: 'Benutzer',
        entities: 'Entitäten',
        access_control: 'Zugriffskontrolle',
        environment: 'Umgebung',
        settings: 'Einstellungen',
        entity_types: 'Entitätstypen',
        configuration: "Konfiguration",
        features_configuration: "Features-Konfiguration"
    },

    configuration: {
        eventConfig: "Feature-Konfiguration",
        eventConfig_paragraph: "Features ein-/ausschalten.",
        comment_button: 'Prozess kommentieren',
        info_button: 'Zusätzliche Informationen anzeigen',
        mail_button: 'Link per Mail verschicken',
        restart_button: 'Prozess neustarten',
        edit_button: "Bearbeiten",
        save_button: "Speichern",
        cancel_button: "Abbrechen",
    },

    header: {
        menu: "Menü",
        profile: 'Profil',
        signout: 'Abmelden'
    },
    main_container: {
        modal_header: 'Sitzung abgelaufen',
        modal_content: ' Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
        errorMessage: 'Seite konnte nicht geladen werden.',
        login_button: 'zum login'
    },


    language: "de",
    data_flow_graph: {
        node: {
            input: "Ein:",
            output: "Aus:"
        },
        toolbar_menu: {
            filter_button: "Filtern",
            from: "Von:",
            to: "Bis:",
            since_prev_day: "Seit Vortag",
            rearrange_button: 'Automatisches Layout',
            save_button: 'Layout speichern',
            auto_save: 'Automatisches speichern',
            save_success: 'Erfolgreich gespeichert',
            save_error: 'Fehler beim Speichern'
        },
        properties: {
            contact_person_header: 'Ansprechpartner',
            information_header: 'Informationen',
            documentation: 'Dokumentation'
        },
        system_properties: {
            process: "Prozess",
            last_success: "Zuletzt erfolgreich",
            last_failure: "Zuletzt fehlerhaft",
            source: "Quelle",
            target: "Ziel",
            in: "Ein",
            out: "Aus"
        },
        connection_properties: {
            process: "Prozess",
            source: "Quelle: ",
            target: " Ziel: ",
            in: " in ",
            runs_in: " Läufe in ",
            failed_runs_in: " Fehler in ",
            pending_runs_in: " Warnungen in ",
            processes: " Prozessen; ",
            information_process: " Prozess; "
        },
        connection_pop_up: {
            runs: "Läufe",
            errors: "Fehler",
            warnings: "Warnungen",
            last: "Zuletzt"
        },
        no_available_systems: "Es sind keine Systeme zur Anzeige verfügbar"
    },
    application_graph: {
        components: {
            sankey_chart: {
                process_instance_id: "Prozess Instanz ID: ",
                start_at: 'Gestartet am: ',
                finished_at: 'Beendet am: ',
                total_number_interface: 'Gesamtanzahl Schnittstellenläufe: ',
                active_interface: 'Aktive Schnittstellenläufe: ',
                errors_number: 'Anzahl Fehler: ',
                faulty_process: 'Fehlerhafte Prozesse: ',
                last_run: 'Zuletzt durchlaufen am: ',
                acute_process: 'Akute Prozesse: ',
                in_sumIn: 'Ein: ',
                out_sumOut: ' | Aus: '
            },
            toolbar_menu: {
                menu_button: 'Seit 17 Uhr Vortag',
                filter_button: 'Filtern',
                rearrange_button: 'Reformatieren'

            }
        }
    },
    common: {
        //simple_filter: "Einfacher Filter",
        //detail_filter: "Detailfilter",
        date_time_picker: {
            from: 'Von',
            to: 'Bis',
            time_caption: "Zeit",
            date_format: 'dd.MM.yyyy - HH:mm',
            locale: 'de',
            false_input_format_text: "Eingabe nicht im Format: {{format}}",
            date_picker: {},
            time_picker: {
                hour: 'Uhr',
                minutes: 'Minuten',
            }
        },
        process_mailer: {
            intro_text: 'Guten Tag',
            msg_text_if: 'würden Sie sich bitte folgenden Prozess ansehen?',
            msg_text_else: 'kannst du dir bitte einmal folgenden Prozess anschauen.',
            farewell_text_1: 'Vielen Dank.',
            farewell_text_2: 'Beste Grüße'
        },
        dtoInterfaces: {
            systemDtoI: {
                System_manager: "Systemverantwortlicher",
                Developer: "Entwickler",
                Administration: "Administration",
                Hotline: "Hotline",
                BusinessConsultant: "Business consultant",
                Business: "Business"
            }
        },
        contact_person_list: {
            employee: "Mitarbeiter",
            contact_details: "Kontaktdaten",
            further_information: "Zusatzinformationen"
        },
        toolbar: {
            filter_options: "Weitere Filteroptionen"
        },
        date_time_formats: {
            date_time: "DD.MM.yyyy HH:mm:ss.SSS",
            date: "DD.MM.yyyy",
            time: "HH:mm:ss.SSS"
        },
        input_dropdown_accordion: {
            add_item_button: "+ Item"
        }
    },
    events: {
        shared_resources: {
            comment_section: {
                conditional_wrapper: 'Kommentar anzeigen.',
                header: 'Anzahl Kommentare:',
                form_placeholder: "Kommentar verfassen...",
                switch_to_unit_of_work: "Zu Unit Of Work wechseln.",
                send_button: 'Senden',
                comment: {
                    unknown_user: "Unbekannter Benutzer",
                }
            },
            comment_button: {
                hide_comment: 'Kommentare ausblenden',
                show_comment: 'Kommentare einblenden'
            },
            additional_information: {
                hint: 'Zusätzliche Informationen anzeigen',
                toast_error: "Es konnten keine zusätzlichen Informationen geladen werden.",
                modal: {
                    header: "Zusätzliche Informationen",
                    contact_person_header: "Ansprechpartner",
                },
                integration_table: {
                    source: "Quelle",
                    target: "Ziel",
                    link: "Link",
                    comment: "Kommentar",
                }
            }
        },
        details: {
            msg_header: 'Semantisch',
            raw_data_item: 'Rohdaten'
        },
        filter_toolbar: {
            processes: "Prozesse",
            unitsOfWork: "Units Of Work",
            checkbox_error: 'Fehler',
            checkbox_warning: 'Warnung',
            checkbox_successful: 'Erfolgreich',
            checkbox_partial_hits: 'Teil-Treffer mit einschließen',
            checkbox_partial_hits_warning: 'Kann Performance einschränken',

            detail_filter: {
                contents: "Inhalte",
                contents_placeholder: "Semantisches Feld",
                process: {
                    process: "Prozess",
                    source: "Quelle",
                    target: "Ziel",
                    processId: "ProzessId",
                    message: "Nachricht",
                },
                unitOfWork: {
                    application: "Applikation",
                    mandant: "Mandant",
                    function: "Funktion"
                }
            }
        },
        process: {
            toast_upload: 'Upload war erfolgreich.',
            table_end: 'ENDE:',
            table_start: 'START:',
            popup_content: 'Prozess per E-Mail teilen',
            unknown: 'Unbekannt'
        },
        process_list: {
            toast_error: "Es ist ein Fehler aufgetreten.",
            placeholder_text: "Es existieren keine Ergebnisse für Ihre Suche.",
            time_header: 'Datum',
            source_header: 'Quelle',
            target_header: 'Ziel',
            name_header: 'Name',
            duration_header: 'Laufzeit',
            link_header: 'Link zum Prozess'
        },
        reprocess: {
            notConfigured: 'Die Wiederverarbeitung wurde für diesen Prozesstypen nicht konfiguriert!'
        },
        unit_of_work: {
            table_end: 'ENDE:',
            table_start: 'START:',
            table_duration: 'LAUFZEIT',
            unknown: 'Unbekannt'
        },
        reprocess_modal: {
            header: "Wiederverarbeitung",
            error_header: "Fehler",
            description: "Die Wiederverarbeitung wird gestartet. Geben Sie einen zusätzlichen Kommentar an!",
            comment_placeholder: "Kommentar",
            cancel_button: "Abbrechen",
            close_button: "Schließen",
            start_reprocessing_button: "Wiederverarbeitung starten",
            start: "Wiederverarbeitung wird gestartet!",
            done: "Wiederverarbeitung gestartet!",
            error_text: "Der Vorgang konnte nicht durchgeführt werden.",
        }
    },
    reprocessing: {
        filter_toolbar: {
            source_placeholder: "Quelle",
            target_placeholder: "Ziel",
            processname_placeholder: "Prozessname",
            application_placeholder: "Applikation",
            function_placeholder: "Funktion",
            mandant_placeholder: "Mandant",
            errormessage_placeholder: "Fehlermeldung",
            select_all_processes_checkbox: "Alle Prozesse selektieren",
            start_mass_reprocessing_button: "Starte Massenverarbeitung",
            detail_view_toggle: "Detailansicht",
        },
        progress_modal: {
            header: "Massenverarbeitung wird durchgeführt",
            success_state: "Die Wiederverarbeitungen wurden erfolgreich gestartet.",
            error_state: "Die Wiederverarbeitungen wurde gestartet. Es sind allerdings Fehler aufgetreten.",
            progress_state: "Es wurden {{value}} von {{length}} Wiederverarbeitungen gestartet.",
            close_button: "Schließen",
        },
        error_modal: {
            header: "Massenverarbeitung konnte nicht durchgeführt werden",
            description: "Es wurde kein Prozess beziehungsweise keine unit of work zum Wiederverarbeiten ausgewählt."
        }
    },
    reporting: {
        process_list_report: {
            loader_text: "Lade...",
            placeholder_text: "Es existieren keine Ergebnisse für Ihre Suche.",
            time_header: 'Datum',
            source_header: 'Quelle',
            target_header: 'Ziel',
            name_header: 'Name',
            duration_header: 'Laufzeit',
            link_header: 'Link zum Prozess'
        },
        ProcessOverviewReport: {
            header_last: 'Letzte 10 Prozesse',
            header_last_errors: 'Letzte 10 Prozesse mit Fehler'
        },
        statistic: {
            unknown : "Unbekannt",
            source_header: 'Quelle',
            target_header: 'Ziel',
            process_name: 'Prozessname',
            count_header: 'Anzahl',
            count_errors: 'Anzahl Fehler',
            count_warnings: 'Anzahl Warnungen',
            error_rate: 'Fehlerrate',
            min_duration: 'Min Laufzeit',
            max_duration: 'Max Laufzeit',
            min_duration_error: 'Min Laufzeit(Fehler)',
            max_duration_error: 'Max Laufzeit(Fehler)',
            avg_duration: 'Avg Laufzeit'
        }
    },
    tooltips: tooltips
};

